import { Component, Input } from '@angular/core';
import { TimeFrameMode } from 'src/app/shared/interfaces/global-filter-model';
import { MondelezDataService } from 'src/app/shared/services/mondelez-data.service';
import { Subscription } from 'rxjs';
import { Chart, registerables } from 'chart.js';
import { GlobalFilterService } from 'src/app/shared/services/global-filter.service';

Chart.register(...registerables);

@Component({
  selector: 'app-capacity-waterfall-chart',
  templateUrl: './capacity-waterfall-chart.component.html',
  styleUrls: ['./capacity-waterfall-chart.component.scss'],
})
export class CapacityWaterfallChartComponent {
  @Input() chartData: any;

  private yearRange = {
    startYear: undefined,
    endYear: undefined,
  };
  public chartObj;
  private timeFrameMode: TimeFrameMode;

  private subs = new Subscription();

  constructor(
    private mondelezDataService: MondelezDataService,
    private globalFilterService: GlobalFilterService,
  ) {}

  ngOnInit(): void {
    // this.yearRange.startYear = this.globalFilterService.getFilterMasterData().iteration_start_year;
    this.subs.add(
      this.globalFilterService.globalFilters.subscribe((filter) => {
        if (filter) {
          this.yearRange.startYear = filter.start_year;
          this.yearRange.endYear = filter.end_year;
        }
      }),
    );
    this.subs.add(
      this.mondelezDataService.timeFrameMode.subscribe((value) => {
        this.timeFrameMode = value;
        this.prepareChart();
      }),
    );
  }

  ngOnChanges(): void {
    if (this.timeFrameMode) {
      this.prepareChart();
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.chartObj?.destroy();
  }

  // private updateChart() {
  //   this.chartObj.data.labels = this.getLabels();
  //   this.chartObj.update();
  // }

  private waterfallArray() {
    let temp = [];
    temp.push([0, this.formatNumbers(this.chartData['initial_capacity'])]);
    temp.push([temp[temp.length - 1][1], temp[temp.length - 1][1] + this.formatNumbers(this.chartData['shifts_improvement'])]);
    temp.push([temp[temp.length - 1][1], temp[temp.length - 1][1] + this.formatNumbers(this.chartData['wastage_improvement'])]);
    temp.push([temp[temp.length - 1][1], temp[temp.length - 1][1] + this.formatNumbers(this.chartData['ge_improvement'])]);
    temp.push([temp[temp.length - 1][1], temp[temp.length - 1][1] + this.formatNumbers(this.chartData['tmax_improvement'])]);
    temp.push([0, this.formatNumbers(this.chartData['increased_performance'])]);
    temp.push([temp[temp.length - 1][1], temp[temp.length - 1][1] + this.formatNumbers(this.chartData['new_improvement'])]);
    temp.push([temp[temp.length - 1][1], temp[temp.length - 1][1] + this.formatNumbers(this.chartData['intervention_capacity'])]);
    temp.push([temp[temp.length - 1][1], temp[temp.length - 1][1] + this.formatNumbers(this.chartData['line_shutdown'])]);
    temp.push([0, this.formatNumbers(this.chartData['improved_capacity'])]);
    return temp;
  }

  private formatNumbers(amt: number) {
    if (!amt) return 0;
    let millionth = amt / 1000000;
    return Math.round(millionth * 10) / 10;
  }

  private prepareChart() {
    var existingChart = Chart.getChart('capacityWaterfall');
    if (existingChart) {
      existingChart.destroy();
    }
    this.chartObj = new Chart('capacityWaterfall', {
      type: 'bar',
      data: {
        labels: [
          `${this.yearRange.startYear} Start`,
          'Shifts',
          'Waste',
          'GE',
          'Line Speed',
          'Inc. Perf',
          'New Lines',
          'Intervention',
          'Line Shutdown',
          `${this.yearRange.endYear} End`,
        ],
        datasets: [
          {
            // label: `${this.yearRange.startYear} Total`,
            borderSkipped: false,
            data: this.waterfallArray(),
            backgroundColor: ['#C4C4CD', '#949494', '#949494', '#949494', '#949494', '#C4C4CD', '#949494', '#949494', '#949494', '#C4C4CD'],
            borderRadius: 4,
            // borderColor: '#2E2E38 ',
            // borderWidth: 1,
            datalabels: {
              color: '#2E2E38 ',
              backgroundColor: '#EAEAF2',
              borderColor: '#2E2E38 ',
              borderRadius: 41,
              borderWidth: 1,
              anchor: 'end',
              align: 'top',
              font: {
                size: 16,
                weight: 'bold',
              },
              padding: {
                top: 2,
                bottom: 2,
                left: 10,
                right: 10,
              },
              display: 'auto',
            },
            // barThickness: 110,
            maxBarThickness: 80,
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        layout: {
          padding: {
            top: 40,
            left: 30,
            right: 30,
          },
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              drawOnChartArea: false,
            },
            ticks: {
              font: {
                size: 18,
                weight: 'bold',
                family: 'Calibri',
                lineHeight: 'normal',
              },
              color: '#212121',
            },
            border: {
              display: false,
            },
          },
          y: {
            stacked: false,
            display: true,
            position: 'left',
            ticks: {
              font: {
                size: 18,
                weight: 'bold',
                family: 'Calibri',
                lineHeight: 'normal',
              },
              color: '#212121',
            },
            border: {
              display: false,
            },
          },
        },
        plugins: {
          datalabels: {
            formatter: function (value, context) {
              return parseFloat((value[1] - value[0]).toFixed(1))
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            },
            color: '#281138',
            backgroundColor: '#9F9F9A',
            borderColor: '#292928',
            borderRadius: 40,
            borderWidth: 1,
            anchor: 'end',
            align: 'top',
            display: 'auto',
            clip: false,
          },
          legend: {
            display: false,
            position: 'bottom',
            align: 'start',
            labels: {
              padding: 20,
            },
          },
        },
      },
    });
  }
}
